module.exports = __webpack_public_path__ + "4a5b5143883f3a761772f55015c6aafd.pdf";